export const TIMEOFF_MANAGER_ACTION = {
  RESET_TIMEOFF_REQUESTS_STATE: "RESET_TIMEOFF_REQUESTS_STATE",
  REQUEST_TIMEOFF_REQUESTS: "REQUEST_TIMEOFF_REQUESTS",
  RESPONSE_TIMEOFF_REQUESTS: "RESPONSE_TIMEOFF_REQUESTS",
  ERROR_TIMEOFF_REQUESTS: "ERROR_TIMEOFF_REQUESTS",


  // Approve Time Off Request
  REQUEST_APPROVE_TIMEOFF_REQUEST: "REQUEST_APPROVE_TIMEOFF_REQUEST",
  RESPONSE_APPROVE_TIMEOFF_REQUEST: "RESPONSE_APPROVE_TIMEOFF_REQUEST",
  ERROR_APPROVE_TIMEOFF_REQUEST: "ERROR_APPROVE_TIMEOFF_REQUEST",
  RESET_APPROVE_TIMEOFF_REQUEST_STATE: "RESET_APPROVE_TIMEOFF_REQUEST_STATE",

  // Get Time Off By ID
  REQUEST_GET_TIMEOFF_BY_ID: "REQUEST_GET_TIMEOFF_BY_ID",
  RESPONSE_GET_TIMEOFF_BY_ID: "RESPONSE_GET_TIMEOFF_BY_ID",
  ERROR_GET_TIMEOFF_BY_ID: "ERROR_GET_TIMEOFF_BY_ID",
  RESET_GET_TIMEOFF_BY_ID_STATE: "RESET_GET_TIMEOFF_BY_ID_STATE",

  // Update Time Off Request
  REQUEST_UPDATE_TIMEOFF_REQUEST: "REQUEST_UPDATE_TIMEOFF_REQUEST",
  RESPONSE_UPDATE_TIMEOFF_REQUEST: "RESPONSE_UPDATE_TIMEOFF_REQUEST",
  ERROR_UPDATE_TIMEOFF_REQUEST: "ERROR_UPDATE_TIMEOFF_REQUEST",
  RESET_UPDATE_TIMEOFF_REQUEST_STATE: "RESET_UPDATE_TIMEOFF_REQUEST_STATE",

  // Create Time Off Request
  REQUEST_CREATE_TIMEOFF_REQUEST: "REQUEST_CREATE_TIMEOFF_REQUEST",
  RESPONSE_CREATE_TIMEOFF_REQUEST: "RESPONSE_CREATE_TIMEOFF_REQUEST",
  ERROR_CREATE_TIMEOFF_REQUEST: "ERROR_CREATE_TIMEOFF_REQUEST",
  RESET_CREATE_TIMEOFF_REQUEST_STATE: "RESET_CREATE_TIMEOFF_REQUEST_STATE",
};

export const setResetTimeOffRequestsState = () => ({
  type: TIMEOFF_MANAGER_ACTION.RESET_TIMEOFF_REQUESTS_STATE,
  data: undefined
});

export const requestTimeOffRequestsAction = (payload) => ({
  type: TIMEOFF_MANAGER_ACTION.REQUEST_TIMEOFF_REQUESTS,
  data: payload
});

export const responseTimeOffRequestsAction = (res) => ({
  type: TIMEOFF_MANAGER_ACTION.RESPONSE_TIMEOFF_REQUESTS,
  data: res
});

export const errorTimeOffRequestsAction = (err) => ({
  type: TIMEOFF_MANAGER_ACTION.ERROR_TIMEOFF_REQUESTS,
  data: err
});

export const requestApproveTimeOffRequestAction = (payload) => ({
  type: TIMEOFF_MANAGER_ACTION.REQUEST_APPROVE_TIMEOFF_REQUEST,
  data: payload
});

export const responseApproveTimeOffRequestAction = (res) => ({
  type: TIMEOFF_MANAGER_ACTION.RESPONSE_APPROVE_TIMEOFF_REQUEST,
  data: res
});

export const errorApproveTimeOffRequestAction = (err) => ({
  type: TIMEOFF_MANAGER_ACTION.ERROR_APPROVE_TIMEOFF_REQUEST,
  data: err
});

export const resetApproveTimeOffRequestState = () => ({
  type: TIMEOFF_MANAGER_ACTION.RESET_APPROVE_TIMEOFF_REQUEST_STATE,
  data: undefined
});

// Get Time Off By ID Actions
export const requestGetTimeOffByIdAction = (id) => ({
  type: TIMEOFF_MANAGER_ACTION.REQUEST_GET_TIMEOFF_BY_ID,
  data: id
});

export const responseGetTimeOffByIdAction = (res) => ({
  type: TIMEOFF_MANAGER_ACTION.RESPONSE_GET_TIMEOFF_BY_ID,
  data: res
});

export const errorGetTimeOffByIdAction = (err) => ({
  type: TIMEOFF_MANAGER_ACTION.ERROR_GET_TIMEOFF_BY_ID,
  data: err
});

export const resetGetTimeOffByIdState = () => ({
  type: TIMEOFF_MANAGER_ACTION.RESET_GET_TIMEOFF_BY_ID_STATE,
  data: undefined
});

// Update Time Off Request Actions
export const requestUpdateTimeOffRequestAction = (payload) => ({
  type: TIMEOFF_MANAGER_ACTION.REQUEST_UPDATE_TIMEOFF_REQUEST,
  data: payload
});

export const responseUpdateTimeOffRequestAction = (res) => ({
  type: TIMEOFF_MANAGER_ACTION.RESPONSE_UPDATE_TIMEOFF_REQUEST,
  data: res
});

export const errorUpdateTimeOffRequestAction = (err) => ({
  type: TIMEOFF_MANAGER_ACTION.ERROR_UPDATE_TIMEOFF_REQUEST,
  data: err
});

export const resetUpdateTimeOffRequestState = () => ({
  type: TIMEOFF_MANAGER_ACTION.RESET_UPDATE_TIMEOFF_REQUEST_STATE,
  data: undefined
});

// Create Time Off Request Actions
export const requestCreateTimeOffRequestAction = (payload) => ({
  type: TIMEOFF_MANAGER_ACTION.REQUEST_CREATE_TIMEOFF_REQUEST,
  data: payload
});

export const responseCreateTimeOffRequestAction = (res) => ({
  type: TIMEOFF_MANAGER_ACTION.RESPONSE_CREATE_TIMEOFF_REQUEST,
  data: res
});

export const errorCreateTimeOffRequestAction = (err) => ({
  type: TIMEOFF_MANAGER_ACTION.ERROR_CREATE_TIMEOFF_REQUEST,
  data: err
});

export const resetCreateTimeOffRequestState = () => ({
  type: TIMEOFF_MANAGER_ACTION.RESET_CREATE_TIMEOFF_REQUEST_STATE,
  data: undefined
});